import { useEffect, useRef } from "react";

/**
 * Custom hook for focusing on headings for accessibility purposes.
 * @param delay - Optional delay in milliseconds before focusing (default: 100ms)
 * @returns Object containing the ref and focus function
 */

export const useFocusHeading = (delay: number = 120) => {
  const headingRef = useRef<HTMLHeadingElement>(null);

  const focusHeading = () => {
    headingRef.current?.focus();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      focusHeading();
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return {
    headingRef,
    focusHeading
  };
};

export const getHeadingProps = (additionalStyles?: React.CSSProperties) => ({
  tabIndex: -1 as const,
  style: { outline: "none", ...additionalStyles } as React.CSSProperties
});
